import { HEADING_COLOR, type BlockComponentProps } from "./shared"

export function TableBlock({ content, resolved }: BlockComponentProps) {
  const th = (content?.heading as string) ?? ""
  const headers = (content?.headers as string[]) ?? []
  const rows = (content?.rows as string[][]) ?? []
  if (headers.length === 0 && rows.length === 0) return null
  const tableSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-8"} ${resolved.cornerClass} ${resolved.alignClass} overflow-x-auto`.trim()
    : "px-4 py-8 @sm:px-6 @md:px-8 overflow-x-auto"
  return (
    <section className={tableSectionClass} style={resolved.sectionStyle}>
      {th && (
        <h2 className="text-2xl font-bold mb-4" style={{ color: HEADING_COLOR }}>
          {th}
        </h2>
      )}
      <div className="max-w-4xl mx-auto rounded-lg border overflow-hidden">
        <table className="w-full text-sm">
          {headers.length > 0 && (
            <thead>
              <tr className="bg-muted/50">
                {headers.map((h, i) => (
                  <th key={i} className="px-4 py-3 text-left font-medium">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {rows.map((row, ri) => (
              <tr key={ri} className="border-t">
                {row.map((cell, ci) => (
                  <td key={ci} className="px-4 py-3">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  )
}
